import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { SanitizeHtmlPipe } from './pipes/sanitize.pipe';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';
import { PdfViewerModule } from 'ng2-pdf-viewer';

import { defineElement } from 'lord-icon-element';
import lottie from 'lottie-web';
import { QuillEditorComponent, QuillModule } from 'ngx-quill';
import { MissingTranslationHandler, MissingTranslationHandlerParams, TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { HttpClient } from '@angular/common/http';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { DateFormatterPipe } from './pipes/date-formatter.pipe';
import { SimplebarAngularModule } from 'simplebar-angular';

import { EulaAgreementComponent } from './components/eula-agreement/eula-agreement.component';
import { PageNotFoundComponent } from './components/page-not-found/page-not-found.component';
import { LoadingSpinnerComponent } from './components/loading-spinner/loading-spinner.component';
import { PageNotAuthorizedComponent } from './components/page-not-authorized/page-not-authorized.component';

export function createTranslateLoader(http: HttpClient): any {
  return new TranslateHttpLoader(http, 'assets/i18n/', '.json');
}

export class MyMissingTranslationHandler implements MissingTranslationHandler {
  handle(params: MissingTranslationHandlerParams) {
		if (params.interpolateParams) {
			const defaultTranslate: any = params.interpolateParams;
			return defaultTranslate['Default'];
		}

		return params.key;
  }
}

@NgModule({
  declarations: [
		SanitizeHtmlPipe,
		DateFormatterPipe,
		EulaAgreementComponent,
		PageNotFoundComponent,
		LoadingSpinnerComponent,
  	PageNotAuthorizedComponent
  ],
  imports: [
    CommonModule,
		NgbModule,
		FormsModule,
		ReactiveFormsModule,
		PdfViewerModule,
		NgSelectModule,
		SimplebarAngularModule,
		QuillModule.forRoot(),
		TranslateModule.forRoot({
      defaultLanguage: 'en',
			missingTranslationHandler: { provide: MissingTranslationHandler, useClass: MyMissingTranslationHandler },
      loader: {
        provide: TranslateLoader,
        useFactory: (createTranslateLoader),
        deps: [HttpClient]
      }
    }),
		QuillEditorComponent
  ],
	exports: [
		SanitizeHtmlPipe,
		DateFormatterPipe,
		NgbModule,
		FormsModule,
		ReactiveFormsModule,
		NgSelectModule,
		TranslateModule,
		SimplebarAngularModule,
		EulaAgreementComponent,
		PdfViewerModule,
		QuillEditorComponent,
		QuillModule,
		PageNotFoundComponent,
		LoadingSpinnerComponent,
		PageNotAuthorizedComponent
	],
	schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class SharedModule {
	constructor() {
    defineElement(lottie.loadAnimation);
  }
}
